module.exports = __webpack_public_path__ + "img/키.eef6b1e5.svg";